import httpClient from '../http/http-client';
import { ISquareFootConversion } from '../transaction/transaction.model';


export default class SquareFootConversionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllSquareFootConversions(): Promise<ISquareFootConversion[]> {
    return this.http.get('square-foot-conversion')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getSquareFootConversionsForConversionSource(conversionSourceId: string, year: string): Promise<ISquareFootConversion[]> {
    return this.http.get(`square-foot-conversion/${conversionSourceId}/conversions?year=${year}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getSquareFootConversionsForConversionSourceWithPagination(conversionSourceId: string, year: string, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: ISquareFootConversion[] }> {
    return this.http.get(`square-foot-conversion/${conversionSourceId}/conversions?year=${year}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}